<form>
  <xena-table sticky-header>
    <xena-column width="40%" i18n="@@import_csv_imported_activity_type">Imported activity type</xena-column>
    <xena-column width="60%" i18n="@@import_csv_Xena_activity_type">Xena activity Type</xena-column>
    <xena-row *ngFor="let mapping of activityTypeMappings.controls" [formGroup]="mapping">
      <xena-cell>{{ mapping.get('salaryType').value }}</xena-cell>
      <xena-cell>
        <xena-autocomplete
        idProperty="id"
        [datasource]="activityTypeDatasource"
        formControlName="activityType"
        listLabelProperty="abbreviation"
        valueLabelProperty="abbreviation"
        debounce="300"
        show-initial-no-result="false"
        no-result-text="No results"
        i18n-no-result-text="@@import_csv_activity_type_noResult" hoist>
          <span slot="error-text" *ngIf="mapping.touched && mapping.invalid"
            i18n="@@import_csv_activity_type_required">Activity type required</span>
        </xena-autocomplete>
      </xena-cell>
    </xena-row>
  </xena-table>
</form>
